/* LUADA Partner Seite - JavaScript (async geladen) */
(function(){
'use strict';

// Tab Switching für Zielgruppen
const tabButtons=document.querySelectorAll('.tab-btn');
const targetContents=document.querySelectorAll('.target-content');

tabButtons.forEach(btn=>{
  btn.addEventListener('click',function(){
    const targetTab=this.getAttribute('data-tab');
    
    tabButtons.forEach(b=>b.classList.remove('active'));
    targetContents.forEach(c=>c.classList.remove('active'));
    
    this.classList.add('active');
    const target=document.getElementById(targetTab);
    if(target){
      target.classList.add('active');
      const wrapper=document.querySelector('.target-content-wrapper');
      if(wrapper){
        wrapper.scrollIntoView({behavior:'smooth',block:'nearest'});
      }
    }
  });
});

// FAQ Accordion
document.querySelectorAll('.faq-question').forEach(q=>{
  q.addEventListener('click',function(){
    const item=this.parentElement;
    const answer=item.querySelector('.faq-answer');
    
    item.classList.toggle('active');
    
    if(item.classList.contains('active')){
      answer.style.maxHeight=answer.scrollHeight+'px';
    }else{
      answer.style.maxHeight='0';
    }
  });
});

// Smooth Scrolling für interne Links
document.querySelectorAll('a[href^="#"]').forEach(a=>{
  a.addEventListener('click',function(e){
    e.preventDefault();
    const target=document.querySelector(this.getAttribute('href'));
    if(target){
      target.scrollIntoView({behavior:'smooth',block:'start'});
    }
  });
});

// Scroll-Animationen mit Intersection Observer
const observerOptions={
  threshold:0.1,
  rootMargin:'0px 0px -50px 0px'
};

const observer=new IntersectionObserver((entries)=>{
  entries.forEach(entry=>{
    if(entry.isIntersecting){
      entry.target.classList.add('animate-in');
    }
  });
},observerOptions);

document.querySelectorAll('.benefit-item').forEach(el=>observer.observe(el));

// Performance: Lazy Loading für Bilder (falls nicht native unterstützt)
if('loading' in HTMLImageElement.prototype){
  // Browser unterstützt native lazy loading
}else{
  // Fallback für ältere Browser
  const lazyImages=document.querySelectorAll('img[loading="lazy"]');
  const imageObserver=new IntersectionObserver((entries,obs)=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){
        const img=entry.target;
        img.src=img.dataset.src||img.src;
        img.classList.add('loaded');
        obs.unobserve(img);
      }
    });
  });
  lazyImages.forEach(img=>imageObserver.observe(img));
}

})();
